var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPurpleBit = function SvgPurpleBit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 161,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.997 143.131c-132.654 0-180.99-243.693-424.401-50.345",
    stroke: "#6C61B9",
    strokeWidth: 35,
    strokeLinecap: "round"
  })));
};
export default SvgPurpleBit;